import { GetAllRunsRequestStatesItem, type RunMetadataDto } from '@/api/control/missionImpactAPI.schemas';

/**
 * Run states in which a run is still queued or executing. A run being cancelled is excluded, since it no
 * longer performs the sync it was created for.
 */
export const ACTIVE_RUN_STATES: GetAllRunsRequestStatesItem[] = [
  GetAllRunsRequestStatesItem.Scheduled,
  GetAllRunsRequestStatesItem.WaitingForSourceCapacity,
  GetAllRunsRequestStatesItem.Extracting,
  GetAllRunsRequestStatesItem.WaitingForTargetLease,
  GetAllRunsRequestStatesItem.Loading,
];

/**
 * Returns the IDs of the source tables that have a queued or executing run among the given runs.
 */
export function getActiveRunTableIds(runs: readonly RunMetadataDto[] | undefined): Set<string> {
  const activeStates = new Set<string>(ACTIVE_RUN_STATES);
  return new Set(
    (runs ?? []).filter((run) => activeStates.has(run.state)).map((run) => run.sourceTableId),
  );
}
